import { createDecorator } from '../../instantiation/common/instantiation.js';
const IMarkerService = ( createDecorator('markerService'));
export { IMarkerService };
